module.exports = __webpack_public_path__ + "static/media/footbal-1.37de9b5f.avif";